document.addEventListener("DOMContentLoaded" ,function(){
    
    const homeAboutSlider = new Swiper(".homeAbout_slider", {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
            nextEl: ".homeAbout_arrow_right",
            prevEl: ".homeAbout_arrow_left",
        },
        breakpoints: {
            800: { slidesPerView: 1.2 },
            1024: { centeredSlides: true, slidesPerView: 2.2, spaceBetween: 20 }
        }
    });
})